export default "__VITE_ASSET__CvHmuItB__"